import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CoreUiModule } from '@isophi/core-ui';

import { BuyLicenseComponent } from './components/buy-license/buy-license.component';
import { ChildSelectorComponent } from './components/child-selector/child-selector.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { DownloadLinkComponent } from './components/download-link/download-link.component';
import { DownloadPreviewComponent } from './components/download-preview/download-preview.component';
import { FooterComponent } from './components/footer/footer.component';
import { GdprInfoComponent } from './components/gdpr-info/gdpr-info.component';
import { FacebookLikePluginComponent } from './components/header/facebook-like-plugin/facebook-like-plugin.component';
import HeaderComponent from './components/header/header.component';
import { LanguagePickerComponent } from './components/language-picker/language-picker.component';
import { LicenseLockModalComponent } from './components/license-lock-modal/license-lock-modal.component';
import { MenuComponent } from './components/menu/menu.component';
import { MoreInfoFormComponent } from './components/more-info-form/more-info-form.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PopUpDialogComponent } from './components/pop-up/components/pop-up-dialog/pop-up-dialog.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { PortfolioPlanNotesComponent } from './components/portfolio-plan-notes/portfolio-plan-notes.component';
import { PortfolioPlanPhotosComponent } from './components/portfolio-plan-photos/portfolio-plan-photos.component';
import { PreviewableComponent } from './components/previewable/previewable.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SocialNetworksIconsComponent } from './components/social-networks-icons/social-networks-icons.component';
import { HoverEffectSidebarDirective } from './directives/hover-effect-sidebar.directive';
import { PreventCopyDirective } from './directives/prevent-copy.directive';
import { SidemenuToggleDirective } from './directives/sidemenuToggle';
import { LayoutComponent } from './pages/layout/layout.component';
import { SafePipe } from './pipes/safe.pipe';
import { WithLoaderPipe } from './pipes/with-loader.pipe';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { WorkInProgressComponent } from './pages/work-in-progress/work-in-progress.component';
import { InfoBannerComponent } from './components/header/info-banner/info-banner.component'
import { WorkplaceInfoComponent } from './components/header/workplace-info/workplace-info.component';
import { InnitialPopupComponent } from './components/innitial-popup/innitial-popup.component';
import { DemoPopupComponent } from './components/demo-popup/demo-popup.component';

const COMPONENTS = [
  MenuComponent,
  FooterComponent,
  HeaderComponent,
  PopUpComponent,
  GdprInfoComponent,
  SocialNetworksIconsComponent,
  SafePipe,
  WithLoaderPipe,
  DownloadPreviewComponent,
  DownloadLinkComponent,
  BuyLicenseComponent,
  PreviewableComponent,
  SidebarComponent,
  LanguagePickerComponent,
  ChildSelectorComponent,
  MoreInfoFormComponent,
  DateInputComponent,
  PortfolioPlanPhotosComponent,
  PortfolioPlanNotesComponent,
  DateRangeFilterComponent,
  LicenseLockModalComponent,
  NotFoundComponent,
  WorkInProgressComponent,
  InfoBannerComponent,
  WorkplaceInfoComponent,
];
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxSpinnerModule,
    TranslocoModule,
    NgSelectModule,
    CoreUiModule,
    TextFieldModule,
  ],
  declarations: [
    ...COMPONENTS,
    PopUpDialogComponent,
    FacebookLikePluginComponent,
    LayoutComponent,
    NavigationComponent,
    HoverEffectSidebarDirective,
    PreventCopyDirective,
    SidemenuToggleDirective,
    InnitialPopupComponent,
    DemoPopupComponent,
  ],
  exports: [...COMPONENTS, PreventCopyDirective, NgxSpinnerModule, TranslocoModule, NgSelectModule, NgbModule, ReactiveFormsModule, CoreUiModule],
  providers: [PopUpComponent],
})
export class SharedModule {
  public static forRoot() {
    return {
      ngModule: SharedModule,
      declarations: [MenuComponent],
      exports: [MenuComponent],
    };
  }
}
